import { render, staticRenderFns } from "./PremiumUpsellBanner.vue?vue&type=template&id=4189f96c&scoped=true"
import script from "./PremiumUpsellBanner.vue?vue&type=script&lang=ts"
export * from "./PremiumUpsellBanner.vue?vue&type=script&lang=ts"
import style0 from "./PremiumUpsellBanner.vue?vue&type=style&index=0&id=4189f96c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4189f96c",
  null
  
)

export default component.exports